$(document).ready(function(){
  $('.owl-carousel').owlCarousel({
    loop:true,
    margin:10,
    nav:true,
    dots:false,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:2
        },
        1000:{
            items:4
        }
    }
});
  
  
   
    $('.home-slider').flexslider({
          animation: "fade",
          animationLoop: true,
          pauseOnHover: false,
          touch: false,
          controlNav: false
    });
  
  

  $('.slides.owl-carousel').owlCarousel({
    items:1,
    loop:true,
    margin:10,
    autoplay:true,
    autoplayTimeout:1000,
    autoplayHoverPause:true,
  responsive:{
        0:{
            items:1
        },
        600:{
            items:1
        },
        1000:{
            items:1
        }
    }});
});


$(window).load(function() {
        var viewportWidth = $(window).width();
        if (viewportWidth < 600) {
            $(".view").removeClass("view view-portfolio").addClass("gallery-mobile");
        }
});

    $(window).resize(function () {
        var viewportWidth = $(window).width();
        if (viewportWidth < 600) {
            $(".view").removeClass("view view-portfolio").addClass("gallery-mobile");
        }
});